export interface CognitoConfig {
  userPoolId: string;
  userPoolClientId: string;
  domain: string;
  redirectSignIn: string[];
  redirectSignOut: string[];
}

export interface RuntimeConfig {
  backendUrl: string;
  backendEnv?: 'local' | 'go-dev' | 'go-prod' | 'wf-prod';
  cognito: CognitoConfig;
  sentryDsn?: string;
  sentryEnvironment?: string;
}

function loadRuntimeConfig(): RuntimeConfig {
  const el = document.getElementById('runtime-config');
  if (!el?.textContent) {
    throw new Error(
      'Runtime config not found. Ensure <script type="application/json" id="runtime-config"> exists in index.html.',
    );
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(el.textContent);
  } catch (e) {
    throw new Error(`Failed to parse runtime config: ${e instanceof Error ? e.message : e}`);
  }

  const config = parsed as Partial<RuntimeConfig>;
  if (typeof config?.backendUrl !== 'string' || !config.backendUrl) {
    throw new Error('Runtime config was not injected: missing backendUrl');
  }
  if (typeof config.cognito?.userPoolId !== 'string') {
    throw new Error('Runtime config was not injected: missing cognito');
  }
  return config as RuntimeConfig;
}

export const runtimeConfig = loadRuntimeConfig();
